module.exports = __webpack_public_path__ + "img/reviews.60e1a252.png";